import React from 'react';
import SvgIcon from '../SvgIconWrapper';

interface ConcreteRIconProps {
  size?: number;
  color?: string;
}

const ConcreteRIcon: React.FC<ConcreteRIconProps> = (props) => (
  <SvgIcon {...props} className="sx-icon-concreter">
    {
      <path d="M15.101 2.957h-6.156c-0.044 0-0.061 18.086-0.061 18.086h6.208c0.044 0 0.014-18.070 0.009-18.086z"></path>

    }  </SvgIcon>
);

export default ConcreteRIcon;
